const LOG_PREFIX = "[OCM][PageSense] "

let pageSense = async (utils) => {
  return new Promise((resolve, reject) => {
    let pageType = 'ROS'
    let sub_paths = window.location.pathname.replace("/", "").split("/") || [];
    let custom_paths = [];

    sub_paths = sub_paths.filter(String);

    if (sub_paths.length === 0) {
      pageType = "Home";
    } else if (sub_paths.length === 1) {
      if (custom_paths.indexOf(sub_paths[0]) >= 0) {
        pageType = "Custom-1";
      } else {
        pageType = "Category";
      }
    } else if (sub_paths.length == 2) {
      if (sub_paths[0] === 'archive') {
        pageType = "Archives";
      }
    } else if (sub_paths.length >= 3) {
      if (sub_paths[0] === 'tag' || sub_paths[0] === "author") {
        pageType = "Tag";
      } else if (sub_paths[0] === 'videos') {
        pageType = "Videos";
      } else {
       // utils.loadScript('//cdn.adsquirrel.ai/ethnos.gr/chirp.js', 'text/javascript')
        pageType = "Article";
      }
    }
    
    // load chirp.js as per pub request https://orangeclickmedia.slack.com/archives/C045ZCA3ASF/p1684226341481949
//     utils.loadScript('//cdn.adsquirrel.ai/ethnos.gr/chirp.js', 'text/javascript', 0)

    window.googletag = window.googletag || {cmd: []}

    // Targeting
    window.googletag.cmd.push(() => {
      window.googletag.pubads().setTargeting('page', [pageType])
      if (pageType === 'Category' || pageType === 'Article') {
        window.googletag.pubads().setTargeting('category', [sub_paths[0]])
      }

      if (pageType === 'Article') {
        window.googletag.pubads().setTargeting('articleId', [sub_paths[sub_paths.length-2]])
      }

      if (pageType === 'Tag') {
        window.googletag.pubads().setTargeting('tag', [sub_paths[2]])
      }
    })
    // -- Targeting

    defineSlots(utils, pageType);

    // setup JP (mobile_sticky and sidesticky)
    window.googletag.cmd.push(function() {
      window.googletag.pubads().addEventListener("slotRenderEnded", function (event) {
        if (
          event.slot.getAdUnitPath().includes('/21771721121/ethnos.gr/mobile_sticky') &&
          event.isEmpty &&
          utils.is_mobile
        ) {
          utils.loadScript('//gr.ads.justpremium.com/adserve/js.php?zone=127407', 'text/javascript');
        } else if (
          event.slot.getAdUnitPath().includes('/21771721121/ethnos.gr/sidesticky') &&
          event.isEmpty &&
          !utils.is_mobile
        ) {
          utils.loadScript('//gr.ads.justpremium.com/adserve/js.php?zone=127319', 'text/javascript');
        }
      });
    });

    utils.loadStyle('#tbl-next-up {z-index: 2147483640 !important}')

    resolve(pageType)
  });
};

let defineSlots = (utils, pageType) => {

  window.googletag.cmd.push(() => {

    let billboard_des = googletag.sizeMapping()
    .addSize([0, 0], [])
    .addSize([340,0], [])
    .addSize([768, 0], [[728,90]])
    .addSize([1024, 0],[[970,250],[970,90],[728,90]])
    .build();

    let billboard = googletag.sizeMapping()
    .addSize([0, 0], [[300,250]])
    .addSize([340,0], [[300,250],[336,280]])
    .addSize([768, 0], [[728,90]])
    .addSize([1024, 0],[[970,250],[970,90],[728,90]])
    .build();

    let ros_infeed = googletag.sizeMapping()
    .addSize([0, 0], [[300,250]])
    //.addSize([340,0], [[300,250],[336,280]])
    .addSize([340,0], [[300,250]])
    .addSize([768, 0], [])
    .addSize([1024, 0],[])
    .build();

    let ros_sidebar_2 = googletag.sizeMapping()
    .addSize([0, 0], [[300,250],[300,600]])
    //.addSize([340,0], [[300,250],[336,280],[300,600]])
    .addSize([340,0], [[300,250],[300,600]])
    .addSize([768, 0], [[300,250]])
    //.addSize([1024, 0],[[300,250],[336,280]])
    .addSize([1024, 0],[[300,250]])
    .build();

    let article_inline_lg = googletag.sizeMapping()
    .addSize([0, 0], [[300,250],[300,600]])
    //.addSize([340,0], [[300,250],[336,280],[300,600]])
    .addSize([340,0], [[300,250],[300,600]])
    .addSize([768, 0], [[300,250]])
    //.addSize([1024, 0],[[300,250],[336,280]])
    .addSize([1024, 0],[[300,250]])
    .build();

    switch(pageType) {
      case 'Home':
        googletag.defineSlot('/21771721121/ethnos.gr/ros_billboard_4', [[970,250],[970,90],[728,90]], 'ros_billboard_4').defineSizeMapping(billboard_des).addService(googletag.pubads())
        //googletag.defineSlot('/21771721121/ethnos.gr/ros_billboard_1', [[970,250],[970,90],[728,90],[300,250],[336,280]], 'ros_billboard_1').defineSizeMapping(billboard).addService(googletag.pubads())
        googletag.defineSlot('/21771721121/ethnos.gr/ros_billboard_1', [[970,250],[970,90],[728,90],[300,250]], 'ros_billboard_1').defineSizeMapping(billboard).addService(googletag.pubads())
        //googletag.defineSlot('/21771721121/ethnos.gr/ros_newsbar_1', [[300,250],[336,280],[300,600]], 'ros_newsbar_1').addService(googletag.pubads())
        googletag.defineSlot('/21771721121/ethnos.gr/ros_newsbar_1', [[300,250],[300,600]], 'ros_newsbar_1').addService(googletag.pubads())
        //googletag.defineSlot('/21771721121/ethnos.gr/ros_billboard_2', [[970,250],[970,90],[728,90],[300,250],[336,280]], 'ros_billboard_2').defineSizeMapping(billboard).addService(googletag.pubads())
        googletag.defineSlot('/21771721121/ethnos.gr/ros_billboard_2', [[970,250],[970,90],[728,90],[300,250]], 'ros_billboard_2').defineSizeMapping(billboard).addService(googletag.pubads())
        // googletag.defineSlot('/21771721121/ethnos.gr/ros_newsbar_2', [[300,250],[336,280],[300,600]], 'ros_newsbar_2').addService(googletag.pubads())
        googletag.defineSlot('/21771721121/ethnos.gr/ros_newsbar_2', [[300,250],[300,600]], 'ros_newsbar_2').addService(googletag.pubads())
        //googletag.defineSlot('/21771721121/ethnos.gr/ros_billboard_3', [[970,250],[970,90],[728,90],[300,250],[336,280]], 'ros_billboard_3').defineSizeMapping(billboard).addService(googletag.pubads())
        googletag.defineSlot('/21771721121/ethnos.gr/ros_billboard_3', [[970,250],[970,90],[728,90],[300,250]], 'ros_billboard_3').defineSizeMapping(billboard).addService(googletag.pubads())
        //googletag.defineSlot('/21771721121/ethnos.gr/home_popular_1', [[300,250],[336,280]], 'home_popular_1').addService(googletag.pubads())
        //googletag.defineSlot('/21771721121/ethnos.gr/home_popular_2', [[300,250],[336,280]], 'home_popular_2').addService(googletag.pubads())
        googletag.defineSlot('/21771721121/ethnos.gr/home_popular_1', [[300,250]], 'home_popular_1').addService(googletag.pubads())
        googletag.defineSlot('/21771721121/ethnos.gr/home_popular_2', [[300,250]], 'home_popular_2').addService(googletag.pubads())

        break;

//       case 'Category':
//       case 'Tag':
//         //googletag.defineSlot('/21771721121/ethnos.gr/ros_infeed', [[300,250],[336,280]], 'ros_infeed').defineSizeMapping(ros_infeed).addService(googletag.pubads())
//         //googletag.defineSlot('/21771721121/ethnos.gr/ros_billboard_1', [[970,250],[970,90],[728,90],[300,250],[336,280]], 'ros_billboard_1').defineSizeMapping(billboard).addService(googletag.pubads())
//         //googletag.defineSlot('/21771721121/ethnos.gr/ros_billboard_2', [[970,250],[970,90],[728,90],[300,250],[336,280]], 'ros_billboard_2').defineSizeMapping(billboard).addService(googletag.pubads())
//         //googletag.defineSlot('/21771721121/ethnos.gr/ros_sidebar_1', [[300,250],[336,280],[300,600]], 'ros_sidebar_1').addService(googletag.pubads())
//         //googletag.defineSlot('/21771721121/ethnos.gr/ros_sidebar_2', [[300,250],[336,280],[300,600]], 'ros_sidebar_2').addService(googletag.pubads())
//         //googletag.defineSlot('/21771721121/ethnos.gr/ros_sidebar_3', [[300,250],[336,280],[300,600]], 'ros_sidebar_3').addService(googletag.pubads())
//         //         googletag.defineSlot('/21771721121/ethnos.gr/ros_infeed', [[300,250]], 'ros_infeed').defineSizeMapping(ros_infeed).addService(googletag.pubads())
// //         googletag.defineSlot('/21771721121/ethnos.gr/ros_billboard_1', [[970,250],[970,90],[728,90],[300,250]], 'ros_billboard_1').defineSizeMapping(billboard).addService(googletag.pubads())
//         googletag.defineSlot('/21771721121/ethnos.gr/ros_billboard_2', [[970,250],[970,90],[728,90],[300,250]], 'ros_billboard_2').defineSizeMapping(billboard).addService(googletag.pubads())
//         googletag.defineSlot('/21771721121/ethnos.gr/ros_sidebar_1', [[300,250],[300,600]], 'ros_sidebar_1').addService(googletag.pubads())
//         googletag.defineSlot('/21771721121/ethnos.gr/ros_sidebar_2', [[300,250],[300,600]], 'ros_sidebar_2').addService(googletag.pubads())
//         googletag.defineSlot('/21771721121/ethnos.gr/ros_sidebar_3', [[300,250],[300,600]], 'ros_sidebar_3').addService(googletag.pubads())
//         break;

//       case 'Article':

//         let s = {'a': 'b','c': 'd','e': 'f','g': 'h','i': 'j','k': 'l','m': 'n','o': 'p','q': 'r','s': 't','w': 'x','y': 'z','z': 'a','b': 'c','d': 'e','f': 'g','h': 'i','j': 'k','l': 'm','n': 'o','p': 'q','r': 's','t': 'w','x': 'y'}

//         let array1 = ['#', s.z, s.f, '-', s.h, s.m, s.q, s.d, s.z, s.c]
//         let array2 = [s.c, s.h, s.r, s.o, s.k, s.z, s.x, ':', s.m, s.n, s.m, s.d]
//         let array3 = [s.r, s.s, s.x, s.k, s.d]

//         let rand = Math.random()
//         let h = (new Date()).getUTCHours()
        
//         if (rand >= 0.30 && (h >= 0 && h <= 7)) {
//           utils.loadStyle(array1.join('') + ' {' + array2.join('') + '}')
//           let el = document.querySelector(array1.join(''))
//           if (el) {
//             el.setAttribute(array3.join(''), '')
//           }
//         }
        
//         //googletag.defineSlot('/21771721121/ethnos.gr/ros_sidebar_1', [[300,250],[336,280],[300,600]], 'ros_sidebar_1').addService(googletag.pubads())
//         //googletag.defineSlot('/21771721121/ethnos.gr/ros_sidebar_2', [[300,250],[336,280],[300,600]], 'ros_sidebar_2').defineSizeMapping(ros_sidebar_2).addService(googletag.pubads())
//         //googletag.defineSlot('/21771721121/ethnos.gr/ros_sidebar_3', [[300,250],[336,280],[300,600]], 'ros_sidebar_3').addService(googletag.pubads())
//         //googletag.defineSlot('/21771721121/ethnos.gr/article_inline_1', [[300,250],[336,280],[300,600]], 'article_inline_1').defineSizeMapping(article_inline_lg).addService(googletag.pubads())
//         //googletag.defineSlot('/21771721121/ethnos.gr/article_inline_2', [[300,250],[336,280],[300,600]], 'article_inline_2').defineSizeMapping(article_inline_lg).addService(googletag.pubads())
//         //googletag.defineSlot('/21771721121/ethnos.gr/article_inline_3', [[300,250],[336,280]], 'article_inline_3').addService(googletag.pubads())
//         //googletag.defineSlot('/21771721121/ethnos.gr/article_end', [[300,250],[336,280]], 'article_end').addService(googletag.pubads())
//         //googletag.defineSlot('/21771721121/ethnos.gr/ros_billboard_2', [[970,250],[970,90],[728,90],[300,250],[336,280]], 'ros_billboard_2').defineSizeMapping(billboard).addService(googletag.pubads())
// //         googletag.defineSlot('/21771721121/ethnos.gr/ros_sidebar_1', [[300,250],[300,600]], 'ros_sidebar_1').addService(googletag.pubads())
// //         googletag.defineSlot('/21771721121/ethnos.gr/ros_sidebar_2', [[300,250],[300,600]], 'ros_sidebar_2').defineSizeMapping(ros_sidebar_2).addService(googletag.pubads())
//         googletag.defineSlot('/21771721121/ethnos.gr/ros_sidebar_3', [[300,250],[300,600]], 'ros_sidebar_3').addService(googletag.pubads())
// //         googletag.defineSlot('/21771721121/ethnos.gr/article_inline_1', [[300,250],[300,600]], 'article_inline_1').defineSizeMapping(article_inline_lg).addService(googletag.pubads())
// //         googletag.defineSlot('/21771721121/ethnos.gr/article_inline_2', [[300,250],[300,600]], 'article_inline_2').defineSizeMapping(article_inline_lg).addService(googletag.pubads())
// //         googletag.defineSlot('/21771721121/ethnos.gr/article_inline_3', [[300,250]], 'article_inline_3').addService(googletag.pubads())
//         googletag.defineSlot('/21771721121/ethnos.gr/article_end', [[300,250]], 'article_end').addService(googletag.pubads())
//         googletag.defineSlot('/21771721121/ethnos.gr/ros_billboard_2', [[970,250],[970,90],[728,90],[300,250]], 'ros_billboard_2').defineSizeMapping(billboard).addService(googletag.pubads())
//         break;

      case 'Archives':
        googletag.defineSlot('/21771721121/ethnos.gr/ros_sidebar_1', [[300,250],[300,600]], 'ros_sidebar_1').addService(googletag.pubads())
        break;

      case 'Videos':
        googletag.defineSlot('/21771721121/ethnos.gr/ros_billboard_1', [[970,250],[970,90],[728,90],[300,250]], 'ros_billboard_1').defineSizeMapping(billboard).addService(googletag.pubads())
        break;

      default:
        break;
    }
  })
}

module.exports = pageSense;